import React from 'react';
import { connect } from 'react-redux';
import { Routes } from '@common-packages/routes-definitions';

import AuthorizedCustomRoute from '../shared/authorization/authorizedCustomRoute';
import GlobalContextPage from '../shared/displayComponents/globalContextPage.component';
import withContextWrapper from '../shared/displayComponents/contextWrapper/withContextWrapperHoc.container';
import { isFetchingGlobalContextSelector } from '../shared/store/selectors';

import CustomScreen from './customScreen.container';

const CustomScreenWithContext = withContextWrapper()(CustomScreen);

const CustomScreenPage = connect(state => ({
  isFetchingContext: isFetchingGlobalContextSelector(state),
}))(GlobalContextPage);

const CustomScreenRoute = () => (
  <AuthorizedCustomRoute
    exact
    path={Routes.customScreen.MAIN}
    wrapper={CustomScreenPage}
    component={CustomScreenWithContext}
    hideGlobalContext
    disableBreadcrumbs
  />
);

export default CustomScreenRoute;
